import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { AddMarginType } from "types/MarginTypes";
import { queryClient } from "App";

export const useCreateMargin = (
  options?: UseMutationOptions<any, Error, AddMarginType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["addMargin"],
    mutationFn: async ({ from, to, margin }) => {
      return axiosInstance
        .post("/margins", {
          from,
          to,
          margin,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie marży...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "add-margin",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Pomyślnie dodano marżę.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "add-margin",
      });
      queryClient.invalidateQueries({ queryKey: ["margins"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.response?.data?.message || "Błąd podczas dodawania marży.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "add-margin",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useCreateMargin;
